import axios from "@/components/api/axios";

const list = request => {
    return axios.post(
        '/company/list',
        request).then(response => response.data)
}

const get = request => {
    return axios.post(
        '/company/get',
        request).then(response => response.data)
}

const add = request => {
    return axios.post(
        '/company',
        request).then(response => response.data)
}

const upd = request => {
    return axios.put(
        '/company',
        request).then(response => response.data)
}

export default {
    get,
    list,
    add,
    upd
}